import React from "react"

import classNames from "classnames"

import { mergeRefs } from "shared/lib/mergeRef"

interface ProductPositionTableRowWrapperProps
  extends React.HTMLProps<HTMLDivElement> {
  index: number
  dragHandleRef?: React.RefObject<HTMLDivElement | null>
  children: React.ReactNode
  isDragDisabled?: boolean
  isLoading?: boolean
  "data-key"?: string
}

export const ProductPositionTableRowWrapper = React.memo(
  React.forwardRef(
    (
      {
        dragHandleRef,
        isDragDisabled,
        children,
        className,
        isLoading,
        index,
        ...rest
      }: ProductPositionTableRowWrapperProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const resolvedRef = mergeRefs<HTMLDivElement>(ref, dragHandleRef)

      return (
        <div
          {...rest}
          className={classNames(
            "project-table-row",
            { loading: isLoading },
            className
          )}
          ref={resolvedRef}
        >
          {children}
        </div>
      )
    }
  )
)
